import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type TTabKey = 'insights' | 'recommendations'
export type TModuleKey = 'bakers' | 'wheat' | 'flour'

export type TTabsState = {
  insights: boolean
  recommendations: boolean
}

export type TInsightsTabsState = {
  [module in TModuleKey]?: {
    [deliveryId: string]: TTabsState
  }
}

export const EMPTY: TTabsState = { insights: false, recommendations: false }

const ensure = (state, module, deliveryId) => {
  state[module] ??= {}
  state[module]![deliveryId] ??= { ...EMPTY }
  return state[module]![deliveryId]!
}

const initialState: TInsightsTabsState = {}

const insightsTabsSlice = createSlice({
  name: 'insightsTabs',
  initialState,
  reducers: {
    toggleTab: (
      state,
      {
        payload,
      }: PayloadAction<{ module: TModuleKey; deliveryId: string; tab: TTabKey }>
    ) => {
      const tabs = ensure(state, payload.module, payload.deliveryId)
      tabs[payload.tab] = !tabs[payload.tab]
    },
    setTabs: (
      state,
      {
        payload,
      }: PayloadAction<{
        module: TModuleKey
        deliveryId: string
        tabs: Partial<TTabsState>
      }>
    ) => {
      const tabs = ensure(state, payload.module, payload.deliveryId)
      Object.assign(tabs, payload.tabs)
    },
    resetDelivery: (
      state,
      { payload }: PayloadAction<{ module: TModuleKey; deliveryId: string }>
    ) => {
      ensure(state, payload.module, payload.deliveryId)
      state[payload.module]![payload.deliveryId] = { ...EMPTY }
    },
    resetAll: () => initialState,
  },
})

export const { toggleTab, setTabs, resetDelivery, resetAll } =
  insightsTabsSlice.actions

export default insightsTabsSlice.reducer
